import React from 'react';
import { useApp } from '../context/AppContext';
import { ROLES } from '../mock';
import { Card, CardContent } from '../components/ui/card';
import { AktaLogo } from '../components/AktaLogo';
import { Label } from '../components/ui/label';
import { Input } from '../components/ui/input';
import DigestPreferences from '../components/DigestPreferences';

const SettingsPage = () => {
  const { user } = useApp();
  const canPickDigest = user?.role === ROLES.ADMIN || user?.role === ROLES.SALES_HEAD;
  return (
    <div className="p-6 md:p-8 max-w-3xl mx-auto space-y-6">
      <div>
        <div className="text-xs uppercase tracking-wider text-muted-foreground font-semibold">Settings</div>
        <h1 className="text-3xl font-bold text-brand-indigo">Profile & Preferences</h1>
      </div>

      {canPickDigest && <DigestPreferences />}
      <Card className="border-brand-border">
        <CardContent className="p-6">
          <div className="flex items-center gap-4 mb-6">
            <AktaLogo size={56} showText={false} />
            <div>
              <div className="font-bold text-brand-indigo text-xl">Akta Wealth</div>
              <div className="text-xs text-muted-foreground">ARN-47282 · Surat, Gujarat</div>
            </div>
          </div>
          <div className="grid md:grid-cols-2 gap-5">
            <div><Label>Name</Label><Input value={user?.name || ''} readOnly className="mt-1 h-11 bg-brand-bg" /></div>
            <div><Label>Email</Label><Input value={user?.email || ''} readOnly className="mt-1 h-11 bg-brand-bg" /></div>
            <div><Label>EUIN</Label><Input value={user?.euin || ''} readOnly className="mt-1 h-11 bg-brand-bg" /></div>
            <div><Label>ARN</Label><Input value={user?.arn || 'ARN-47282'} readOnly className="mt-1 h-11 bg-brand-bg" /></div>
          </div>
        </CardContent>
      </Card>

      <Card className="border-brand-border">
        <CardContent className="p-6 space-y-3 text-xs text-brand-indigo/80 leading-relaxed">
          <div className="text-sm font-semibold text-brand-indigo">Compliance</div>
          <div>Akta Wealth (ARN-47282) is an AMFI Registered Mutual Fund Distributor. This app is used exclusively by internal Relationship Managers to conduct financial awareness and suitability assessments as required under the AMFI Code of Conduct for Mutual Fund Distributors.</div>
          <div>All sessions are logged for AMFI / SEBI inspection compliance and retained for a minimum of 5 years.</div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SettingsPage;
